import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["urlInput", "submitButton"]

  connect() {
    this.element.addEventListener("ajax:success", this.handleSuccess.bind(this))
    this.element.addEventListener("ajax:error", this.handleError.bind(this))
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("ajax:success", this.handleSuccess.bind(this))
    this.element.removeEventListener("ajax:error", this.handleError.bind(this))
    this.element.removeEventListener("submit", this.handleSubmit.bind(this))
  }

  async handleSubmit(event) {
    event.preventDefault()
    
    const formData = new FormData(this.element)
    const targetUrl = formData.get("target_url")
    
    if (!targetUrl || !this.isValidUrl(targetUrl)) {
      this.showError("Please enter a valid URL (http:// or https://)")
      return
    }

    this.setLoading(true)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (data.success) {
        this.handleSuccess(data)
      } else {
        this.handleError(data)
      }
    } catch (error) {
      console.error("Replay request failed:", error)
      this.showError("Network error: Failed to send replay request")
    } finally {
      this.setLoading(false)
    }
  }

  handleSuccess(data) {
    this.showSuccess(data.message || "Replay request sent successfully!")
    this.urlInputTarget.value = "" // Clear the input
  }

  handleError(data) {
    this.showError(data.message || "Failed to send replay request")
  }

  setLoading(loading) {
    this.submitButtonTarget.disabled = loading
    if (loading) {
      this.submitButtonTarget.textContent = "Sending..."
      this.submitButtonTarget.classList.add("opacity-50")
    } else {
      this.submitButtonTarget.textContent = "Replay"
      this.submitButtonTarget.classList.remove("opacity-50")
    }
  }

  showSuccess(message) {
    this.showToast(message, "success")
  }

  showError(message) {
    this.showToast(message, "error")
  }

  showToast(message, type) {
    // Create a simple toast notification
    const toast = document.createElement("div")
    toast.className = `fixed top-4 right-4 z-50 px-4 py-3 rounded-md shadow-lg transition-all duration-300 transform translate-x-full ${
      type === "success" ? "bg-green-100 text-green-800 border border-green-200" : "bg-red-100 text-red-800 border border-red-200"
    }`
    toast.textContent = message

    document.body.appendChild(toast)

    // Slide in
    setTimeout(() => {
      toast.classList.remove("translate-x-full")
    }, 100)

    // Slide out and remove
    setTimeout(() => {
      toast.classList.add("translate-x-full")
      setTimeout(() => {
        if (document.body.contains(toast)) {
          document.body.removeChild(toast)
        }
      }, 300)
    }, 4000)
  }

  isValidUrl(string) {
    try {
      const url = new URL(string)
      return url.protocol === "http:" || url.protocol === "https:"
    } catch (_) {
      return false
    }
  }
} 